export default __webpack_public_path__ + "static/media/release7.901761b8.jpeg";